import { withStyles } from 'material-ui/styles';
import React, { Component } from 'react';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { Button, TextField } from 'material-ui';

import axios from 'axios/index';
import {
    DialogActions
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import ReactTable from "react-table";

import moment from 'moment';
import 'react-day-picker/lib/style.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';



const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});


class DeliveryNote extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),

            isQuotation: false,
            referenceNumber: '',
            invoiceNumber: '',
            invoiceList: [],
            rawInvoices: [],

            customerTypes: [],
            customerType: 'All',
            customerCodes: [],
            customerCode: '',
            customerNames: [],
            customerName: null,
            customers: [],
            customerReferenceNumber: '',
            deliveryAddress:
            {
                address: '',
                country: '',
                state: '',
                city: '',
                zipcode: '',
                mobile: '',
                telephone: '',
                fax: '',
                email: ''
            },
            customerOfInvoice: {},

            selectedItems: [],
            itemList: []

        };

        this.handletransactionDateChange = this.handletransactionDateChange.bind(this);
        // this.getInvoiceDetails();
        this.populateData();
    }

    handletransactionDateChange(date) {
        console.log('changeDate', date);
        this.setState({ transactionDate: date });
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleDeliveryDataChange = prop => event => {
        var value = event.target.value;

        this.setState(prevState => ({
            deliveryAddress: {
                ...prevState.deliveryAddress,
                [prop]: value
            }
        }));
    };

    populateData() {
        this.getCustomerTypes();
        this.getCustomers();
        this.getInovices();

        if (this.props.location.state && this.props.location.state.refNo) {
            this.props.alert.success('Getting data. Please wait');
            this.getInvoiceDetails(this.props.location.state.refNo);
        }
    }

    getInovices() {
        console.log('getting invoices...');

        this.setState({ loading: true });
        const request = axios.get(window.salesServer + '/invoice/getInvoiceIdAndRefNo');
        request.then((response) => {
            var customerOfInvoice = {};

            if (!response.data.error && response.data.result) {
                //console.log('data recieved', response.data);
                let invoiceList = [];
                for (let i = 0; i < response.data.result.length; i++) {
                    invoiceList.push({ value: response.data.result[i].ID_INVOICE_HEADER, label: response.data.result[i].REFERENCE_NO, });
                    customerOfInvoice[response.data.result[i].ID_INVOICE_HEADER] = response.data.result[i].CUSTOMER_ID;
                }
                this.setState({ invoiceList: invoiceList, customerOfInvoice: customerOfInvoice, rawInvoices: response.data.result });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    getCustomerTypes() {
        console.log('getting customer types...');
        //this.setState({ loading: true });
        const request = axios.get(window.systemServer + '/system/loadCustomerTypes');
        request.then((response) => {
            if (window.DATABASE_TYPE == "MYSQL")
                if (response.data.success) {

                    let data = [];
                    data = (response.data.result.slice());
                    this.setState({ customerTypes: data });
                    // let customerTypes = [{ value: 'all', label: 'All' }];
                    let customerTypes = [];
                    for (let i = 0; i < response.data.result.length; i++) {
                        customerTypes.push({ value: response.data.result[i].customer_type, label: response.data.result[i].customer_type });
                    }
                    this.setState({ customerTypes: customerTypes });


                    this.setState({ loading: false });
                }
                else {

                    this.setState({ loading: false });
                }
            else
                if (!response.data.error) {
                    //console.log('data recieved', response.data);
                    let data = [];
                    data = (response.data.slice());
                    this.setState({ customerTypes: data });
                    // let customerTypes = [{ value: 'all', label: 'All' }];
                    let customerTypes = [];
                    for (let i = 0; i < response.data.length; i++) {
                        customerTypes.push({ value: response.data[i].customer_type, label: response.data[i].customer_type });
                    }
                    this.setState({ customerTypes: customerTypes });


                    this.setState({ loading: false });
                }
                else {
                    console.log('error', response.data.error);
                    this.setState({ loading: false });
                }
        });
    }

    getCustomers() {
        console.log('getting customers...');

        this.setState({ loading: true });
        const request = axios.get(window.crmServer + '/crm/getCustomer/all');
        request.then((response) => {

            if (!response.data.error) {
                //console.log('data recieved', response.data);
                let customerCodes = [];
                let customerNames = [];
                for (let i = 0; i < response.data.length; i++) {
                    customerCodes.push({ value: response.data.result[i]._id, label: response.data.result[i].CUSTOMER_CODE });
                    customerNames.push({ value: response.data.result[i]._id, label: response.data.result[i].CUSTOMER_PROFILE.cx_name });
                }
                this.setState({ customerCodes: customerCodes });
                this.setState({ customerNames: customerNames });
                this.setState({ customers: response.data.result });

                this.setState({ loading: false });
            }
            else {
                console.log('error', response.data.error);
                this.setState({ loading: false });
            }
        });
    }

    customersByCustomerType() {

        let customerCodes = [];
        let customerNames = [];

        for (let i = 0; i < this.state.customers.length; i++) {
            if (this.state.customerType == 'All') {
                customerCodes.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE });
                customerNames.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name });
            }
            else if (this.state.customerType == this.state.customers[i].CUSTOMER_PROFILE.cx_type) {
                customerCodes.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE });
                customerNames.push({ value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name });
            }

        }

        var c = { customerCodes: customerCodes, customerNames: customerNames };

        return c;
    }

    getInvoiceDetails(refNo) {
        this.setState({ loading: true });

        let body = {
            referenceNo: refNo
        };

        var url = window.salesServer + "/invoice/getInvoiceDetailsByRefNo";
        const request = axios.post(url, body);



        request.then((response) => {
            if (response.data && !response.data.error && response.data.success == true) {
                console.log('invoice details', response.data);
                if (response.data.result.invoiceItems) {
                    this.setState({ itemList: response.data.result.invoiceItems });
                }
                if (response.data.result.invoiceHeader) {
                    this.setState({ referenceNumber: '' });
                }

                console.log('getInvoiceDetailsByRefNo ', response);
                let body2 = { id: response.data.result.invoiceHeader.CUSTOMER_ID };
                console.log('body2', body2);
                var url2 = window.crmServer + "/crm/getCustomer/byId";
                const request2 = axios.post(url2, body2);
                request2.then((response2) => {
                    if (!response2.data.error) {
                        console.log('customer details', response2.data);
                        this.setState(
                            {
                                customerType: response2.data.result[0].CUSTOMER_PROFILE.cx_type,
                                customerCode: response2.data.result[0]._id,
                                customerName: response2.data.result[0]._id,
                                invoiceNumber: response.data.result.invoiceHeader.ID_INVOICE_HEADER
                            }
                        );

                        this.setState(prevState => ({
                            deliveryAddress: {
                                ...prevState.deliveryAddress,
                                address: response2.data.result[0].CUSTOMER_PROFILE.cx_postal_address,
                                country: response2.data.result[0].CUSTOMER_PROFILE.cx_postal_address_country,
                                state: response2.data.result[0].CUSTOMER_PROFILE.cx_postal_address_state,
                                city: response2.data.result[0].CUSTOMER_PROFILE.cx_postal_address_city,
                                zipcode: response2.data.result[0].CUSTOMER_PROFILE.cx_postal_address_zipcode
                            }
                        }));

                        if (response2.data.result[0].CONTACT_PERSONS.length > 0) {
                            this.setState(prevState => ({
                                deliveryAddress: {
                                    ...prevState.deliveryAddress,
                                    mobile: response2.data.result[0].CONTACT_PERSONS[0].phone_mobile,
                                    telephone: response2.data.result[0].CONTACT_PERSONS[0].phone_office,
                                    email: response2.data.result[0].CONTACT_PERSONS[0].email,
                                    fax: response2.data.result[0].CONTACT_PERSONS[0].fax
                                }
                            }));
                        }
                        this.props.alert.success('Data retreived from Invoice')
                        this.setState({ loading: false });

                    }
                })
                    .catch((error) => {
                        this.props.alert.error('Loading data from invoice failed');
                        console.log('Loading data from invoice failed', error);
                        this.setState({ loading: false });
                    })
            } else {
                this.props.alert.error('Data error');
                this.setState({ loading: false });
                console.log('response success false', response);
            }
        })
            .catch((error) => {
                if (error && error != undefined) {
                    this.props.alert.error('Loading data from invoice failed');
                    console.log('Loading data from invoice failed', error);
                }
                this.setState({ loading: false });

            });

    }

    handleCusTypeChange = (selectedOption) => {
        if (selectedOption) {
            this.setState({ customerType: selectedOption.value, /* customerType2:selectedOption.value */ })
        }
        else {
            this.setState({ customerType: 'All',/*  customerType2: 'all' */ });
        }
    }

    handleCusCodeChange = (selectedOption) => {
        console.log('cuscodechange called', selectedOption);
        console.log('cuscodechange called', this.state.rawInvoices);

        if (selectedOption) {

            for (let i = 0; i < this.state.customers.length; i++) {
                console.log('cuscodechange loop', this.state.customers[i]._id, selectedOption.value);

                if (this.state.customers[i]._id == selectedOption.value) {
                    console.log('found', this.state.customers[i]._id, selectedOption.value);
                    this.setState({ customerName: { value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_PROFILE.cx_name } });
                    this.setState({ customerCode: { value: selectedOption.value, label: this.state.customers[i].CUSTOMER_CODE } });
                    this.setState({ customerType: this.state.customers[i].CUSTOMER_PROFILE.cx_type });

                    break;
                }
            }

            console.log(`Selected: ${selectedOption.value}`);
        }
        else {
            this.setState({ customerCode: '' });
            this.setState({ customerName: '', customerType: 'All', /* customerType2: 'all' */ });
        }

        let invoiceList = [];
        for (let i = 0; i < this.state.rawInvoices.length; i++) {
            if (selectedOption) {
                if (this.state.rawInvoices[i].CUSTOMER_ID == selectedOption.value) {
                    invoiceList.push({ value: this.state.rawInvoices[i].ID_INVOICE_HEADER, label: this.state.rawInvoices[i].REFERENCE_NO, });
                }
            }
            else {
                invoiceList.push({ value: this.state.rawInvoices[i].ID_INVOICE_HEADER, label: this.state.rawInvoices[i].REFERENCE_NO, });
            }
        }

        this.setState({ invoiceList: invoiceList });
    }

    handleCusNameChange = (selectedOption) => {

        if (selectedOption) {
            this.setState({ customerName: selectedOption });
            for (let i = 0; i < this.state.customers.length; i++) {
                if (this.state.customers[i]._id == selectedOption.value) {
                    this.setState({ customerCode: { value: this.state.customers[i]._id, label: this.state.customers[i].CUSTOMER_CODE } });
                    this.setState({ customerType: this.state.customers[i].CUSTOMER_PROFILE.cx_type });
                    break;
                }
            }
            console.log(`Selected: ${selectedOption.value}`);
        }
        else {
            this.setState({ customerName: '' });
            this.setState({ customerCode: '', customerType: 'All', /* customerType2: 'all' */ });
        }

        let invoiceList = [];
        for (let i = 0; i < this.state.rawInvoices.length; i++) {
            if (selectedOption) {
                if (this.state.rawInvoices[i].CUSTOMER_ID == selectedOption.value) {
                    invoiceList.push({ value: this.state.rawInvoices[i].ID_INVOICE_HEADER, label: this.state.rawInvoices[i].REFERENCE_NO, });
                }
            }
            else {
                invoiceList.push({ value: this.state.rawInvoices[i].ID_INVOICE_HEADER, label: this.state.rawInvoices[i].REFERENCE_NO, });
            }
        }

        this.setState({ invoiceList: invoiceList });
    }

    handleInoviceChange = (selectedOption) => {

        if (selectedOption) {
            this.setState({ invoiceNumber: selectedOption.value });

            this.getInvoiceDetails(selectedOption.label);
            this.setState(
                {
                    customerCode: this.state.customerOfInvoice[selectedOption.value],
                    customerName: this.state.customerOfInvoice[selectedOption.value],
                }
            );


        }
        else {
            this.setState({ invoiceNumber: '' });
        }
    }

    handleClearClick = () => {
        this.setState({
            transactionDate: moment(new Date()).format("YYYY-MM-DD"),

            referenceNumber: '',
            invoiceNumber: '',
            customerType: 'All',
            customerCodes: [],
            customerCode: '',
            customerName: null,
            customerReferenceNumber: '',
            deliveryAddress:
            {
                address: '',
                country: '',
                state: '',
                city: '',
                zipcode: '',
                mobile: '',
                telephone: '',
                fax: '',
                email: ''
            },
            itemList: []
        });
    };

    handleSaveClick = () => {

        var customerCode = '';
        var customerName = '';
        if (this.state.customerCode && !this.state.customerCode == '') {
            console.log('filter customer by code ', this.state.customerCode);
            var filtered1 = this.state.customerCodes.filter(record => record.value == this.state.customerCode);
            var filtered2 = this.customersByCustomerType().customerNames.filter(record => record.value == this.state.customerName);
            console.log('filtered1', filtered1);
            console.log('filtered2', filtered2);
            if (filtered1 && filtered1.length > 0) {
                customerCode = filtered1[0].label;
            }
            if (filtered2 && filtered2.length > 0) {
                customerName = filtered2[0].label;
            }
        }

        let deliveryNote = {
            REFERENCE_NO: this.state.referenceNumber,
            TRANSACTION_DATE: this.state.transactionDate,
            CUSTOMER_ID: this.state.customerCode.value ? this.state.customerCode.value : this.state.customerCode,
            CUSTOMER_TYPE: this.state.customerType,
            CUSTOMER_CODE: customerCode,
            CUSTOMER_NAME: customerName,
            ID_INVOICE_HEADER: this.state.invoiceNumber,
            ADDRESS: this.state.deliveryAddress.address,
            COUNTRY: this.state.deliveryAddress.country,
            STATE: this.state.deliveryAddress.state,
            CITY: this.state.deliveryAddress.city,
            ZIP_CODE: this.state.deliveryAddress.zipcode,
            MOBILE: this.state.deliveryAddress.mobile,
            TELEPHONE: this.state.deliveryAddress.telephone,
            FAX: this.state.deliveryAddress.fax,
            EMAIL: this.state.deliveryAddress.email,
        };

        console.log('deliveryNote', deliveryNote);

        this.setState({ loading: true });
        var url = window.salesServer + "/invoice/saveDeliveryNote";
        const request = axios.post(url, { "deliveryNote": deliveryNote });

        request.then((response) => {
            if (!response.data.error && response.data.success) {
                console.log('delivery note saved', response);
                this.props.alert.success('Save successful. Delivery Number ' + response.data.deliveryNumber);
                this.getDeliveryNoteReport(response.data.deliveryId);
            }
            else {
                this.props.alert.error('Save unsuccessful');
                console.log('Save unsuccessful', response);
            }
            this.setState({ loading: false });
        })
            .catch((error) => {
                this.props.alert.error('Save unsuccessful');
                this.setState({ loading: false });
            });
    }

    getDeliveryNoteReport(deliveryId) {
        console.log('getDeliveryNoteReport called', deliveryId);
        var path = null;
        // axios.get('http://localhost:5008/report/get/deliveryNote', {
        axios.get(window.reportServer + '/report/get/deliveryNote', {
            params: {
                id: deliveryId
            }
        })
            .then(response => {
                console.log('getDeliveryNoteReport path', response);
                path = response.data.path;
                path = window.reportServer + "/" + path;
                // path = "http://localhost:5008/" + path;
                const url = path;
                window.open(url, '_blank');
            }
            )
            .catch((error) => {
                if (error) {
                    console.log('getDeliveryNoteReport error', error);
                } else {
                    console.log('getDeliveryNoteReport error');
                }
            });
    }


    componentWillMount() { }

    render() {
        const { selectedDay } = this.state;
        const parseDate = '2018-06-06';

        var divStyle = (value, stateC) => {
            if (stateC == value) {
                return { display: 'inline-block', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };

        var divStyleBlock = (value, stateC) => {
            if (stateC == value) {
                return { display: 'block', margin: 0 };
            }
            else {
                return { display: 'none', margin: 0 };
            }
        };

        var blockStyle = { display: 'block', margin: 0 };

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        const { classes } = this.props;

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Delivery Note</h2>
                    </div>

                    <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 delevery-note-form-color">
                        <div className="p-8">

                            <div className="w-full sm:w-1/3 md:w-1/6  inline-block">
                                <TextField
                                    id="name"
                                    label="Reference Number"
                                    className="w-full px-4"
                                    className={classes.textField}
                                    classes={{
                                        input: classes.input
                                    }}
                                    value={this.state.referenceNumber}
                                    onChange={this.handleTextBoxChange('referenceNumber')}
                                />
                            </div>

                            {/* <div className="w-full sm:w-1/3 md:w-1/6 inline-block">
                            <p>Transaction Date:</p>
                            <DayPickerInput className="bg-orange" onDayChange={this.handletransactionDateChange} selectedDays={this.state.transactionDate}
                            placeholder={"YYYY-MM-DD"}/>

                        </div> */}

                            <div className="w-full sm:w-1/3 md:w-1/6  inline-block delevery-text-feild-margin">
                                <TextField
                                    id="name"
                                    className="w-full px-4"
                                    className={classes.textField}
                                    classes={{
                                        input: classes.input
                                    }}
                                    label="Transaction Date"
                                    placeholder="Select Date"
                                    type="date"
                                    value={this.state.transactionDate}
                                    onChange={this.handleTextBoxChange('transactionDate')}
                                />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 invoice-form-color">
                        <div className="pt-8" >

                            <div className="w-1/5 inline-block">
                                Customer Type
                                <Select
                                    className="w-full"
                                    name="form-field-name"
                                    placeholder="Select Customer Type"
                                    value={this.state.customerType}
                                    onChange={this.handleCusTypeChange}
                                    //options={this.state.customerNames}
                                    options={this.state.customerTypes}
                                />
                            </div>

                            <div className="w-1/5  inline-block delevery-text-feild-margin">
                                Customer Code
                                <Select
                                    className="w-full"
                                    name="form-field-name"
                                    placeholder="Search Cusotmer Code"
                                    value={this.state.customerCode}
                                    onChange={this.handleCusCodeChange}
                                    //options={this.state.customerCodes}
                                    options={this.customersByCustomerType().customerCodes}
                                />
                            </div>

                            <div className="w-1/5   inline-block delevery-text-feild-margin">
                                Customer Name
                                <Select
                                    className="w-full"
                                    name="form-field-name"
                                    placeholder="Search Customer Name"
                                    value={this.state.customerName}
                                    onChange={this.handleCusNameChange}
                                    //options={this.state.customerNames}
                                    options={this.customersByCustomerType().customerNames}
                                />
                            </div>

                            <div className="w-1/5   inline-block delevery-text-feild-margin">
                                Invoice
                                <Select
                                    className="w-full"
                                    name="form-field-name"
                                    placeholder="Search Invoice"
                                    value={this.state.invoiceNumber}
                                    onChange={this.handleInoviceChange}
                                    options={this.state.invoiceList}
                                />
                            </div>
                        </div>


                        <div className="delevery-note-second-margin">
                            <div className="w-full  sm:w-1/3 md:w-1/6 inline-block my-8">
                                <div className="w-full px-20  inline-block">
                                    <TextField
                                        id="address"
                                        label="Address"
                                        className="w-full px-4"
                                        className={classes.textField}
                                        classes={{
                                            input: classes.input
                                        }}
                                        value={this.state.deliveryAddress.address}
                                        onChange={this.handleDeliveryDataChange('address')}
                                    />
                                </div>
                            </div>

                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="cpuntry"
                                        label="Country"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.country}
                                        onChange={this.handleDeliveryDataChange('country')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="state"
                                        label="State"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.state}
                                        onChange={this.handleDeliveryDataChange('state')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="city"
                                        label="City"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.city}
                                        onChange={this.handleDeliveryDataChange('city')}
                                    />
                                </div>
                            </div>

                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="zipcode"
                                        label="Zip Code"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.zipcode}
                                        onChange={this.handleDeliveryDataChange('zipcode')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 ">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="mobile"
                                        label="Mobile"
                                        type="number"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.mobile}
                                        onChange={this.handleDeliveryDataChange('mobile')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="telephone"
                                        label="Telephone"
                                        type="number"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.telephone}
                                        onChange={this.handleDeliveryDataChange('telephone')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="fax"
                                        label="Fax"
                                        type="number"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.fax}
                                        onChange={this.handleDeliveryDataChange('fax')}
                                    />
                                </div>
                            </div>
                            <div className="w-full sm:w-1/3 md:w-1/6 inline-block my-8 delevery-text-feild-margin">
                                <div className="md:w-1/4 px-20 -mt-12 inline-block">
                                    <TextField className=""
                                        id="email"
                                        label="Email"
                                        className={classes.textField}
                                        value={this.state.deliveryAddress.email}
                                        onChange={this.handleDeliveryDataChange('email')}
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <div className="mt-8 mr-16  p-8 pb-16">
                        <ReactTable
                            data={this.state.itemList}
                            columns={[

                                {
                                    Header: "Item Code",
                                    accessor: "ITEM_ID"
                                },
                                {
                                    Header: "Item Name",
                                    accessor: "ITEM_NAME"
                                },
                                {
                                    Header: "Quantity",
                                    accessor: "ITEM_QTY"
                                }
                            ]}
                            pageSize={this.state.itemList.length > 3 ? this.state.itemList.length : 3}
                            //defaultPageSize={10}
                            className="-striped -highlight"
                        />
                    </div>

                    <DialogActions className=" justify-right pl-16  ">

                        <Button variant="raised" size="small" color="secondary" className="{classes.button} w-full delevery-btn-size md:w-1/5 mx- 8 mt-16 float-right "
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.handleSaveClick();
                            }}
                        >
                            Save
                        </Button>

                        <Button variant="raised" size="small" color="primary" className="{classes.button} w-full delevery-btn-size md:w-1/5 mx-8 mt-16 float-right"
                            onClick={(ev) => {
                                ev.stopPropagation();
                                this.handleClearClick();
                            }}
                        >
                            Clear
                        </Button>

                    </DialogActions>

                    <div className="delevery-note-button"></div>


                </div>
            )


        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(DeliveryNote));


// WEBPACK FOOTER //
// ./src/main/content/sales/deliveryNote/DeliveryNote.js